/**
 * @file automatically generated from MApp.Data.Entity.ActiveDirectoryType
 */

export enum ActiveDirectoryType {
    None = 0,
    OnPremise = 1,
    Azure = 2,
    WsFed = 3,
    OpenIdConnect = 4
}
